module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av506-9215d03e701da36da91e6bf176da7b1b.jpg";